import React from 'react'
import { useState, useEffect, useContext, useRef, useReducer } from "react";
import { RxDotsVertical } from "react-icons/rx";
import { CgAttachment } from "react-icons/cg";

function MediaSelect({ mediaData, wrapperData }) {


  const [mediaDropdown, setMediaDropdown] = mediaData;

  const handleMediaSelect = (i, e) => {
    mediaDropdown[i].onClick(e);
    setOpenWrapperMedia(false)
  }
  const wrapperRefMedia = React.useRef(null);
  const [openWrapperMedia, setOpenWrapperMedia] = wrapperData;
  useOutsideAlerter(wrapperRefMedia, setOpenWrapperMedia);

  function useOutsideAlerter(ref, setX) {
    React.useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setX(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, setX]);
  }


  return (
    <div
      ref={wrapperRefMedia} className="relative flex w-fit">
      <div
        onClick={() => setOpenWrapperMedia((prev) => !prev)}
        className="flex items-center">
        <button type="button" className="inline-flex justify-center p-1 text-gray-500 rounded-lg cursor-pointer hover:text-headPrimary hover:bg-our-200 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-600">
          <CgAttachment className="w-4 h-4 md:w-5 md:h-5" />
        </button>
      </div>

      {/* ---------------MENU DROPDOWN ------------ */}
      <div style={{ "position": "revert-layer", "zIndex": 1 }}
        className={`py-2 top-8 left-0 min-w-[200px] md:min-w-[230px] absolute z-10 origin-[17px_-10px] transition-all duration-200 ease-in-out ${openWrapperMedia ? "scale-100" : "scale-0"}`}
      >
        <div
          className={`grid grid-cols-2 gap-1 p-1.5  rounded-xl border-gray-600 border bg-white shadow-md dark:!bg-navy-800 dark:text-white dark:shadow-none`}>

          {mediaDropdown.map((item, ind) => (

            <div
              // onClick={() => console.log(item.name)}
              key={item.name} className="flex w-full items-center hover:font-bold">

              <label htmlFor={`dropzone-file-` + item.name} className='hover:bg-lightPrimary  group cursor-pointer h-full w-full rounded-lg p-0.5 text-sm md:text-base flex items-center'>

                <div className="text-gray-400 group-hover:text-headPrimary mr-2">
                  {item.icon}
                </div>
                <div className="">
                  {item.name}
                </div>

                <input
                  id={`dropzone-file-` + item.name} key={item.name} type="file" className="hidden"
                  accept={item.allowed}
                  onChange={(e) => { handleMediaSelect(ind, e) }}
                />
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default MediaSelect